import React from "react";
import { useTranslation } from "react-i18next";

export default function GetEndpointById() {
  const { t } = useTranslation("help");

  return (
    <div className="endpoint-container">
      <a href="#get-endpoint" className="endpoint-title">
        {t("getEndpointById.title", "Get Endpoint by ID")}
      </a>

      <pre className="code-block">
        <code>
{`import requests

API_KEY = ""  # ${t("getEndpointById.required", "Required")}
SESSION_KEY = "" #  ${t("getEndpointById.required", "Required")}
ENDPOINT_CONFIG_ID = ""  # ${t("getEndpointById.required", "Required")}

url = f"https://demo.whitehax.com/api/endpoint-config/getEndpointConfigById/{ENDPOINT_CONFIG_ID}"

headers = {"Authorization": API_KEY, "X-Session-Key": SESSION_KEY}

response = requests.request("GET", url, headers=headers)

print(response.text)`}
        </code>
      </pre>

      <style>{`
        .endpoint-container {
          width: 100%;
          box-sizing: border-box;
          background: #1f1f1f;
          color: #f5f5f5;
          padding: 0;
          font-family: Arial, Helvetica, sans-serif;
        }

        .endpoint-title {
          display: inline-block;
          margin-bottom: 22px;
          color: #fff;
          font-size: 16px;
          font-weight: 600;
          text-decoration: underline;
          cursor: pointer;
        }

        .endpoint-title:hover {
          color: #b7ddf2;
        }

        .code-block {
          margin: 0;
          padding: 0;
          background: transparent;
          color: #d4d4d4;
          font-family: Consolas, "Courier New", monospace;
          font-size: 14px;
          line-height: 1.45;
          white-space: pre-wrap;
          overflow-x: auto;
        }

        .code-block code {
          font-family: inherit;
        }
      `}</style>
    </div>
  );
}